'use strict';

/**
 * stores module
 */
require(['vue', 'storesApp', 'vueLazyload', 'modal', 'es6PromiseAuto', 'polyfill'], function (Vue, storesApp, VueLazyload, VModal) {
  /* eslint no-new: "off" */
  Vue.config.productionTip = false;
  Vue.use(VueLazyload, {
    preLoad: 1.3,
    loading: require.toUrl('images/spinner.svg'),
    attempt: 2
  });
  // 使用modal
  Vue.use(VModal.default, { componentName: 'modal' });
  // 实例化vue
  new Vue({
    el: '#app',
    template: '<storesApp/>',
    components: {
      storesApp: storesApp
    }
  });
});
define("Transsion_Pickup/modules/stores", function(){});

